import QuizSubmissionDialogs from 'components/ViewQuiz/QuizSubmissionDialogs';
import { useViewport } from 'contexts/viewport';
import ErrorPage from 'pages/Error/404';
import Desktop from 'pages/ViewQuiz/desktop';
import Mobile from 'pages/ViewQuiz/mobile';
import { PageContext } from 'pages/ViewQuiz/PageProvider';
import Tablet from 'pages/ViewQuiz/tablet';
import { useContext } from 'react';
import { Loading } from 'shell/components';

const PageLayout = () => {
    const { device } = useViewport();
    const { quiz, loading, loadFailed, ...props } = useContext(PageContext);

    if (loading && !quiz) return <Loading />;
    if (!quiz && loadFailed) return <ErrorPage />;
    if (!quiz) return <Loading />;

    const page = {
        mobile: <Mobile quiz={quiz} {...props} />,
        tablet: <Tablet quiz={quiz} {...props} />,
        desktop: <Desktop quiz={quiz} {...props} />,
    }[device];
    return (
        <>
            {page}
            <QuizSubmissionDialogs {...props.submissionImport} />
        </>
    );
};

export default PageLayout;
